import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/reset.css'
import './utils/rem'
import { mixin } from '@/mixins'

Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.mixin(mixin);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
